import { render, staticRenderFns } from "./SelecionaProgramacao.vue?vue&type=template&id=43a1411b"
import script from "./SelecionaProgramacao.vue?vue&type=script&lang=js"
export * from "./SelecionaProgramacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports